import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentLivePreviewComponent } from './content-live-preview/content-live-preview.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [ContentLivePreviewComponent],
  imports: [
    CommonModule,
    NgbModule
  ],
  exports: [ContentLivePreviewComponent]
})
export class ContentLivePreviewModule { }
